import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import SyntaxHighlighter from 'react-syntax-highlighter'
import { zenburn } from 'react-syntax-highlighter/styles/hljs'
import { Redirect } from 'react-router-dom'
import cx from 'classnames'
import ScrollToTopOnMount from '../../components/componentUtils/scrollToTopOnMount'
import UpdatePageTitle from '../../utils/common'
import './styles.css'

const createMarkup = content => ({ __html: content })

const Article = ({ match }) => {
  const { year, month, articleName } = match.params
  let articleContent = ''
  try {
    const fileNameBeforeExtension = `${year}_${month}_${articleName.replace(/-/g, '_')}`
    articleContent = require(`../../assets/articles/${fileNameBeforeExtension}.json`)
    UpdatePageTitle(articleContent.title)
  } catch (e) {
    return <Redirect to='/articleNotFound' />
  }
  return (
    <section className={cx('section')}>
      <ScrollToTopOnMount />
      <h1 className={cx('section-header')}>{articleContent.title}</h1>
      <div className={cx('article-content')}>
        <div className={cx('article-subtitle-meta')}>
          {moment(`${year}/${month}`, 'YYYY/MM').format('MMM YYYY')}
        </div>
        {/* Top Image */}
        <img
          className={cx('article-image')}
          src={require(`../../assets/images/${articleContent.topImage}`)}
          alt=''
        />
        {/* Article Content */}
        {articleContent.contentBlocks.map((block) => {
          switch (block.kind) {
            case 'image':
              return (
                <img
                  className={cx('article-image')}
                  key={block.sectionID}
                  src={require(`../../assets/images/${block.imageSource}`)}
                  alt=''
                />
              )
            case 'para':
              return <p key={block.sectionID} dangerouslySetInnerHTML={createMarkup(block.content)} />
            case 'code':
              return (
                <SyntaxHighlighter
                  key={block.sectionID}
                  language={block.language}
                  style={zenburn}
                  customStyle={{ fontSize: '16px' }}
                >
                  {block.content}
                </SyntaxHighlighter>
              )
            case 'header':
              return <h2 key={block.sectionID}>{block.content}</h2>
            case 'list':
              return (
                <ul key={block.sectionID}>
                  {block.content.map((item, itemIndex) => (
                    <li key={itemIndex} dangerouslySetInnerHTML={createMarkup(item)} />
                  ))}
                </ul>
              )
            case 'videoEmbed':
              return (
                <div className={cx('embed-wrapper')}>
                  <div
                    key={block.sectionID}
                    className={cx('embed-container')}
                    dangerouslySetInnerHTML={createMarkup(block.content)}
                  />
                </div>
              )
            default:
              return ''
          }
        })}
      </div>
    </section>
  )
}

Article.propTypes = {
  match: PropTypes.object,
}

Article.defaultProps = {
  match: {},
}

export default Article



// WEBPACK FOOTER //
// ./src/client/containers/article/index.js